import "./style.scss";
import "./style-mob.scss";
import { Link } from "react-router-dom";
import RedLineForTitle from "@/src/components/RedLineForTitle/RedLineForTitle";

const TrainingFormatsDescription = () => {
  return (
    <div className="training-formats-description">
      <RedLineForTitle title={"Форматы обучения"} />
      <div className="training-formats-description-text">
        <p>
          <strong>Мальтийская школа медицины и бизнеса</strong> предлагает различные форматы
          обучения, чтобы каждый студент мог выбрать наиболее удобный и эффективный для себя путь.
          Независимо от выбранной формы — очной, дистанционной или полностью онлайн — вы получаете
          одинаково качественное образование.
        </p>
        <p>
          <strong>Очная форма обучения</strong> идеально подходит для тех, кто стремится к полной
          интеграции в университетскую жизнь. Это лучший выбор для студентов, которые ценят живое
          взаимодействие с преподавателями, возможность участвовать в дискуссиях и получать
          немедленную обратную связь. Личное присутствие на занятиях способствует более глубокому
          усвоению материала и развитию практических навыков в реальном времени. Помимо этого, очное
          обучение позволяет активно участвовать в студенческих мероприятиях, заводить полезные
          знакомства.
        </p>
        <p>
          <strong>Дистанционная (онлайн) форма обучения</strong> подойдёт тем, кто ценит гибкость и
          свободу в планировании своего времени. Этот формат идеален для студентов, которые
          совмещают учёбу с работой, предпринимательской деятельностью или другими обязанностями, а
          также для тех, кто проживает в других регионах или странах. Занятия проходят в
          онлайн-среде, где вы можете самостоятельно выбирать темп обучения, возвращаться к
          материалам и повторять сложные темы при необходимости.
        </p>
      </div>
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </div>
  );
};

export default TrainingFormatsDescription;
